module.exports = __webpack_public_path__ + "static/media/verdeSweetheart_wide.819e29e3.jpg";